import { BYBETJENTTEAMHISTORIKK } from "../actions/bybetjenterActions";
import { CreateNewReducer } from "../utils/reducerUtils";

const byBetjentTeamHistorikkReducer = (state = [], action) =>
  CreateNewReducer(state, action, BYBETJENTTEAMHISTORIKK);

export default byBetjentTeamHistorikkReducer;
